/* v20 catalog structurer: page bodies + product descriptions */

(function(){
  document.querySelectorAll('[data-ctfk]').forEach(function(root){
  var src=root.querySelector('.ctfk__src');if(!src)return;
  var H=/^H[12]$/;
  var kids=[].slice.call(src.children);
  var intro=[],chapters=[],cur=null;
  kids.forEach(function(el){
    if(el.tagName==='HR')return;
    if(H.test(el.tagName)){cur={h:el,items:[]};chapters.push(cur);}
    else if(cur){cur.items.push(el);}else{intro.push(el);}
  });
  if(!chapters.length){src.classList.add('ctfk__plain');src.classList.add('ctfk__done');return;}
  function txt(el){return (el.textContent||'').replace(/\s+/g,' ').trim();}
  var title=root.getAttribute('data-title')||(document.querySelector('.ctfh2__h')||{}).textContent||'';
  // first chapter that is just the page name / brand line becomes intro
  var c0=chapters[0];
  if(c0&&(/^CUTTHROAT FORGED\s*[—\/-]/i.test(txt(c0.h))||/^(CONTACT CUTTHROAT FORGED|OUR MISSION|RETURNS & POLICIES|SHIPPING & LEAD TIMES|ORDER → PRODUCTION → SHIPPING)$/i.test(txt(c0.h))||txt(c0.h).toLowerCase().indexOf(title.trim().toLowerCase().slice(0,18))===0)){
    intro=intro.concat(c0.items);chapters.shift();
  }
  var out=document.createElement('div');out.className='ctfk__out';
  var divT=root.querySelector('.ctfk__divtpl'),stripT=root.querySelector('.ctfk__striptpl');
  function divider(){if(divT)out.appendChild(divT.content.cloneNode(true));}
  if(intro.length){var ib=document.createElement('div');ib.className='ctfk__intro';intro.forEach(function(e){ib.appendChild(e)});out.appendChild(ib);}
  var info=null,n=0,grid=null,stripDone=false;
  var CLOSERS=/^(OUR PROMISE|JOIN THE MOVEMENT|READY TO|WANT TO GET STARTED|QUESTIONS ABOUT|NEED HELP|STEP INTO|CARE = LONGEVITY)/i;
  var NUM=/^(STEP\s*)?(\d{1,2})[\.\s—–-]+\s*/i;
  chapters.forEach(function(c,i){
    var t=txt(c.h);
    if(/^HOURS, LOCATION/i.test(t)){
      info=document.createElement('div');info.className='ctfk__info';
      c.items.forEach(function(p){(p.innerHTML.split(/<br[^>]*>/i)).forEach(function(line){var d=document.createElement('div');d.innerHTML=line;var s=txt(d);if(!s)return;var m=s.match(/^([^:]{2,20}):\s*(.+)$/);var b=document.createElement('div');b.className='ctfk__infob';b.innerHTML=m?'<span>'+m[1]+'</span><b>'+d.innerHTML.replace(/^[^:]*:\s*/,'')+'</b>':'<b>'+d.innerHTML+'</b>';info.appendChild(b);});});
      out.insertBefore(info,out.firstChild&&out.firstChild.classList&&out.firstChild.classList.contains('ctfk__intro')?out.firstChild.nextSibling:out.firstChild);
      return;
    }
    if(!c.items.length){grid=null;var gl=document.createElement('p');gl.className='ctfk__glabel';gl.textContent=t;out.appendChild(gl);return;}
    var len=c.items.reduce(function(a,e){return a+txt(e).length},0);
    if(CLOSERS.test(t)&&len<520){
      grid=null;var q=document.createElement('blockquote');q.className='ctfk__band';
      q.innerHTML='<p class="ctfk__bandk">'+c.h.innerHTML+'</p>';c.items.forEach(function(e){q.appendChild(e)});out.appendChild(q);return;
    }
    var m=t.match(NUM);
    n++;
    var hasSub=c.items.some(function(e){return e.tagName==='H3'||e.tagName==='H4'});
    if(m&&!hasSub){
      if(!grid){grid=document.createElement('div');grid.className='ctfk__grid';out.appendChild(grid);}
      var card=document.createElement('div');card.className='ctfk__card';
      var num=('0'+m[2]).slice(-2);
      var h=document.createElement('h3');h.textContent=t.replace(NUM,'');
      card.innerHTML='<span class="ctfk__bignum">'+num+'</span>';card.appendChild(h);
      c.items.forEach(function(e){card.appendChild(e)});grid.appendChild(card);return;
    }
    grid=null;
    var blk=document.createElement('article');blk.className='ctfk__spec';
    var hd=document.createElement('header');hd.innerHTML='<span class="ctfk__num">'+('0'+n).slice(-2)+'</span>';
    var h2=document.createElement('h2');h2.innerHTML=c.h.innerHTML;hd.appendChild(h2);blk.appendChild(hd);
    var body=document.createElement('div');body.className='ctfk__body';
    if(hasSub){
      var pre=[],cards=[],cc=null;
      c.items.forEach(function(e){if(e.tagName==='H3'||e.tagName==='H4'){cc={h:e,items:[]};cards.push(cc);}else if(cc){cc.items.push(e)}else pre.push(e)});
      pre.forEach(function(e){body.appendChild(e)});
      var g=document.createElement('div');g.className='ctfk__sub';
      cards.forEach(function(x,j){var cd=document.createElement('div');cd.className='ctfk__subc';var tt=txt(x.h);var mm=tt.match(NUM);cd.innerHTML='<span class="ctfk__mini">'+('0'+(mm?mm[2]:j+1)).slice(-2)+'</span>';var h4=document.createElement('h3');h4.textContent=mm?tt.replace(NUM,''):tt;cd.appendChild(h4);x.items.forEach(function(e){cd.appendChild(e)});g.appendChild(cd)});
      body.appendChild(g);
    }else{
      c.items.forEach(function(e){
        if(e.tagName==='P'&&e.firstElementChild&&e.firstElementChild.tagName==='STRONG'&&e.querySelector('br')&&txt(e.firstElementChild).length<120&&/\?$/.test(txt(e.firstElementChild))){e.classList.add('ctfk__qa');}
        body.appendChild(e);
      });
    }
    blk.appendChild(body);out.appendChild(blk);
    if(!stripDone&&n===2&&stripT){out.appendChild(stripT.content.cloneNode(true));stripDone=true;}
  });
  src.innerHTML='';src.appendChild(out);src.classList.add('ctfk__done');
});
})();
